import script from './SdsTabBadge.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sds-tab-badge",class:( _obj = {
        'sds-tab-badge-type--new': _vm.isNewBadge,
        'sds-tab-badge-background--default': !_vm.background
    }, _obj[("sds-tab-badge-background--" + _vm.background)] = !!_vm.background, _obj )},[_vm._t("default")],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-7c34207a_0", { source: ".sds-tab-badge[data-v-7c34207a]{padding:1px 6px;text-align:center;border-radius:var(--radius-full);font-size:var(--system-label-small-bold-size);font-weight:600;line-height:var(--system-label-small-bold-line-height);letter-spacing:var(--system-label-small-bold-letter-spacing)}.sds-tab-badge-background--default[data-v-7c34207a]{color:var(--component-tabs-on-elevation-badge-text-active);background-color:var(--component-tabs-on-elevation-badge-bg-active)}.sds-tab-badge-background--default.sds-tab-badge-type--new[data-v-7c34207a]{color:var(--system-text-on-info-primary);background-color:var(--system-bg-info)}.sds-tab-badge-background--dark-color[data-v-7c34207a]{color:var(--component-tabs-on-brand-badge-text-active);background-color:var(--component-tabs-on-brand-badge-bg-active)}.sds-tab-badge-background--dark-color.sds-tab-badge-type--new[data-v-7c34207a]{color:var(--component-tabs-on-brand-badge-text-active);background-color:var(--component-tabs-on-brand-badge-bg-active)}.sds-tab-badge-background--bright-color[data-v-7c34207a]{color:var(--component-tabs-on-generosity-badge-text-active);background-color:var(--component-tabs-on-generosity-badge-bg-active)}.sds-tab-badge-background--bright-color.sds-tab-badge-type--new[data-v-7c34207a]{color:var(--component-tabs-on-generosity-badge-text-active);background-color:var(--component-tabs-on-generosity-badge-bg-active)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-7c34207a";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
